import type { RendererProps } from '../type';

import { BlockStack, Box } from '@shopify/polaris';
import { OrderCell } from './OrderCell';

export type OrderCellContainerProps = Pick<
  RendererProps,
  'value' | 'columnLayout' | 'orderCellProps' | 'previousValue' | 'isTotalRow'
>;
export const OrderCellContainer: React.FC<OrderCellContainerProps> = ({
  value,
  columnLayout,
  orderCellProps,
  previousValue,
  isTotalRow,
}) => {
  return (
    <BlockStack align="center">
      <Box width="100%">
        <OrderCell
          value={value}
          columnLayout={columnLayout}
          orderCellProps={orderCellProps}
          isTotalRow={isTotalRow}
        />
      </Box>
      {typeof previousValue === 'string' && (
        <Box width="100%">
          <OrderCell
            value={previousValue}
            columnLayout={columnLayout}
            orderCellProps={orderCellProps}
            isPrevious
            isTotalRow={isTotalRow}
          />
        </Box>
      )}
    </BlockStack>
  );
};
